import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { SearchPanel } from "../AppLayout/SearchPanel/SearchPanel";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import { actions } from "react-redux-form";
import { Container, Row, Col, Navbar, Nav, NavItem, NavLink } from "reactstrap";
import { isMobile } from "react-device-detect";
import { DeliveryChannels } from "./DeliveryChannels";
import ReactTooltip from "react-tooltip";
import {
  homeActions,
  fileActions,
  documentActions,
} from "../../../redux/actions";
import {
  getDocumentsWithoutPlatformSpecificParams,
  getFilesParams,
} from "../../../utils";
import {
  initDocsSearchFormState,
  initFilesSearchFormState,
} from "../../../utils/constants";
import "./Home.css";

const INTERVALTIME = 3000 * 60;

class Home extends React.Component {
  state = {
    activeSummaryTab: "prod",
    pasting: false,
    beforePasting: "",
  };

  componentDidMount() {
    const {
      dispatch,
      subUser,
      homeSearch: { CustomerId: subCustomerId },
    } = this.props;
    if (subUser) {
      const { customerGlobalId } = subUser;
      dispatch(actions.change(`homeSearch.CustomerId`, customerGlobalId));
      dispatch(
        homeActions.getFilesBucketsStates(subCustomerId || customerGlobalId)
      );
      this.interval = setInterval(function () {
        dispatch(
          homeActions.getFilesBucketsStates(subCustomerId || customerGlobalId)
        );
      }, INTERVALTIME);
    }
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  handleParamChange = (paramName, paramValue) => {
    const {
      dispatch,
      subUser: { customerGlobalId },
      homeSearch: { CustomerId: subCustomerId },
    } = this.props;
    dispatch(actions.change(`homeSearch.${paramName}`, paramValue));
    if (paramName === "ProjectId") return;
    if (paramName === "CustomerId") {
      if (this.interval) clearInterval(this.interval);
      dispatch(
        homeActions.getFilesBucketsStates(paramValue || customerGlobalId)
      );

      this.interval = setInterval(function () {
        dispatch(
          homeActions.getFilesBucketsStates(paramValue || customerGlobalId)
        );
      }, INTERVALTIME);
      return;
    }
    const fileRegex = new RegExp(
      /([a-zA-Z0-9\s_\\.\-\(\):])+(\.[a-z]{3,4})$/, // eslint-disable-line
      "i"
    );
    //eslint-disable-next-line
    const ebidRegex = new RegExp(/^BEL[a-zA-Z0-9]{32}$/, "i");
    const _params = {
      PageNumber: 1,
      Size: 2,
    };

    let fileSearchStarted = false,
      documentSearchStarted = false;

    if (paramValue.match(ebidRegex)) {
      dispatch(
        homeActions.getFilteredDocsbyEBID(
          getDocumentsWithoutPlatformSpecificParams({
            ..._params,
            DocId: paramValue,
          }),
          true,
          subCustomerId || customerGlobalId
        )
      );
      documentSearchStarted = true;
    }
    if (paramValue.match(fileRegex)) {
      // start search for the file
      dispatch(
        homeActions.getFilteredFiles(
          getFilesParams(
            {
              ..._params,
              FileNames: paramValue,
            },
            true,
            subCustomerId || customerGlobalId
          )
        )
      );
      fileSearchStarted = true;
    }

    if (this.state.pasting && !documentSearchStarted && !fileSearchStarted) {
      var oldval = this.state.beforePasting;
      if (oldval !== paramValue) {
        this.performSearch(paramValue);
      }
      this.setState({ pasting: false });
      return;
    }
  };

  handleRowClick(e, file) {
    let _el = e.target;
    let _action = _el.getAttribute("data-action");
    switch (_action) {
      case "open_documentbucketall":
        let qData = {
          file_event_id: file.fileId,
        };
        if (file.fidfs) {
          qData["fidfs"] = file.fidfs;
        }
        var qs = require("qs");
        this.props.dispatch(documentActions.resetDocuments());
        this.props.history.push("/documents?" + qs.stringify(qData));
        break;
      default:
        break;
    }
  }

  navigateToFileDocs = (file) => {
    this.props.dispatch(documentActions.resetDocuments());

    let qData = {
      file_event_id: file.file.eventid,
      fidfs: file.fidfs,
    };
    var qs = require("qs");
    this.props.history.push("/documents?" + qs.stringify(qData));
  };

  navigateToFile = (e) => {
    const {
      dispatch,
      translate,
      history,
      subUser: { customerGlobalId },
      homeSearch: { CustomerId },
    } = this.props;

    let _el = e.target;
    let _action = _el.getAttribute("data-action");
    let _run = _el.getAttribute("data-run");

    var _to = new Date(),
      _from = new Date();

    switch (_action) {
      case "24h":
        _from.setDate(_from.getDate() - 1);
        dispatch(
          actions.change("fileSearch", {
            ...initFilesSearchFormState,
            Start: _from,
            End: _to,
            Run: _run,

            CustomerId,

            moreArrowIcon: "fa-chevron-up",
            toggleBtnTitle: "Hide advanced search options",
            showMoreHeight: "auto",
          })
        );
        this.props.dispatch(
          fileActions.getAll(
            getFilesParams(
              {
                ...initFilesSearchFormState,
                Start: _from,
                End: _to,
                Run: _run,
              },
              true,
              CustomerId || customerGlobalId
            ),
            `${translate("LoadingFiles")}...`
          )
        );
        history.push("/files");
        break;
      case "7d":
        _from.setDate(_from.getDate() - 7);
        dispatch(
          actions.change("fileSearch", {
            ...initFilesSearchFormState,
            Start: _from,
            End: _to,
            Run: _run,
            CustomerId,

            moreArrowIcon: "fa-chevron-up",
            toggleBtnTitle: "Hide advanced search options",
            showMoreHeight: "auto",
          })
        );
        dispatch(
          fileActions.getAll(
            getFilesParams(
              {
                ...initFilesSearchFormState,
                Start: _from,
                End: _to,
                Run: _run,
              },
              true,
              CustomerId || customerGlobalId
            ),
            `${translate("LoadingFiles")}...`
          )
        );
        history.push("/files");
        break;
      default:
        break;
    }
  };

  navigateToDocs = (e) => {
    const {
      dispatch,
      translate,
      history,
      subUser: { customerGlobalId },
      homeSearch: { CustomerId },
    } = this.props;

    let _el = e.target;
    let _action = _el.getAttribute("data-action");
    let _run = _el.getAttribute("data-run");

    var _to = new Date(),
      _from = new Date();

    switch (_action) {
      case "24h":
        _from.setDate(_from.getDate() - 1);
        dispatch(documentActions.clearDocuments());
        dispatch(
          actions.change("docSearch", {
            ...initDocsSearchFormState,
            Start: _from,
            End: _to,
            Run: _run,
            CustomerId,

            moreArrowIcon: "fa-chevron-up",
            toggleBtnTitle: "Hide advanced search options",
            showMoreHeight: "auto",
          })
        );
        dispatch(
          documentActions.getAll(
            getDocumentsWithoutPlatformSpecificParams(
              {
                ...initDocsSearchFormState,
                Start: _from,
                End: _to,
                Run: _run,
              },
              true,
              CustomerId || customerGlobalId
            ),
            `${translate("LoadingDocuments")}...`
          )
        );
        history.push("/documents");
        break;
      case "7d":
        _from.setDate(_from.getDate() - 7);
        dispatch(documentActions.clearDocuments());
        dispatch(
          actions.change("docSearch", {
            ...initDocsSearchFormState,
            Start: _from,
            End: _to,
            Run: _run,
            CustomerId,

            moreArrowIcon: "fa-chevron-up",
            toggleBtnTitle: "Hide advanced search options",
            showMoreHeight: "auto",
          })
        );
        dispatch(
          documentActions.getAll(
            getDocumentsWithoutPlatformSpecificParams(
              {
                ...initDocsSearchFormState,
                Start: _from,
                End: _to,
                Run: _run,
              },
              true,
              CustomerId || customerGlobalId
            ),
            `${translate("LoadingDocuments")}...`
          )
        );
        history.push("/documents");
        break;
      default:
        break;
    }
  };

  getIncomingFiles = (files) => {
    const { translate } = this.props;
    return (
      <table
        className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
        cellSpacing="0"
        style={{ border: "0px", padding: "0px", display: "table" }}
      >
        <thead className="grids_header">
          <tr style={{ fontSize: ".8rem" }}>
            <th>{translate("FileName")}</th>
            <th className="hidden-sm-screen-home">
              {translate("ArrivalTime")}
            </th>
            <th style={{ textAlign: "right", padding: "0 1em" }}>
              <span className="hidden-very-sm-screen-search">
                {translate("Documents")}
              </span>
              <span className="hidden-not-very-sm-screen-search">Docs</span>
            </th>
            <th className="text-center hidden-sm-screen-home">
              {translate("Status")}
            </th>
          </tr>
        </thead>
        <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
          {files &&
            files.map((item, index) => (
              <tr
                key={index}
                className="row_tr"
                onClick={(e) => {
                  this.handleRowClick(e, item);
                }}
              >
                <td className={"name-column home-row-status-" + item.status}>
                  {item.mode === "test" && <i>[TEST] </i>}
                  {item.fileName}
                </td>
                <td className="hidden-sm-screen-home">
                  {item.arrivalTime
                    ? moment
                        .utc(item.arrivalTime, moment.ISO_8601)
                        .format("DD-MM-YYYY HH:mm:ss")
                    : "n/a"}
                </td>
                {item.documentsCount > 0 ? (
                  <td
                    className="w_p_action finger w_p_action_tooltip file-docs-column"
                    data-action="open_documentbucketall"
                    data-container="body"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Open Documents"
                    style={{ textAlign: "right", padding: "0 1em" }}
                  >
                    <div
                      className="file-docs-inner tooltip-btn"
                      data-action="open_documentbucketall"
                      style={{ fontSize: "1em" }}
                    >
                      <span
                        data-action="open_documentbucketall"
                        className="fa fa-file ls-screen-hidden"
                        style={{ marginRight: "0.5em", fontSize: "1.2em" }}
                      />
                      {item.documentsCount}{" "}
                      <span
                        data-action="open_documentbucketall"
                        className="fa fa-file-alt hidden-sm-screen"
                        style={{ fontSize: "1.5em" }}
                      />
                    </div>
                  </td>
                ) : (
                  <td className="text-center">TBD</td>
                )}

                <td
                  className="hidden-sm-screen-home"
                  style={{ width: "180px" }}
                >
                  <div
                    style={{
                      textTransform: "uppercase",
                      float: "left",
                      textAlign: "center",
                      marginLeft: "1.5em",
                    }}
                    className={"tag-status-label status-" + item.status}
                  >
                    {this.props.translate(item.status)}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  getFormatedValueStr = (n, c, d, t) => {
    var c = isNaN((c = Math.abs(c))) ? 0 : c,
      d = d === undefined ? "." : d,
      t = t === undefined ? " " : t,
      s = n < 0 ? "-" : "",
      i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
      j = (j = i.length) > 3 ? j % 3 : 0;

    return (
      s +
      (j ? i.substr(0, j) + t : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
      (c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : "")
    );
  };

  handleOpenFilesFromFile = (file) => {
    this.props.dispatch(fileActions.resetFiles())

    let qData = {
      fileId: file.file.eventid,
      fidFs: file.fidfs,
    };
    var qs = require("qs");
    this.props.history.push("/files?" + qs.stringify(qData));
  };

  handleOpenFilesFromDoc = (doc) => {
    let qData = {
      fileId: doc.rooteventid,
    };
    if (doc.fidFs) {
      qData["fidFs"] = doc.fidFs;
    }
    var qs = require("qs");
    this.props.history.push("/files?" + qs.stringify(qData));
  };

  handleOpenDocument = (documentId) => {
    let qData = {
      DocUniqueId: documentId,
    };
    this.props.dispatch(documentActions.clearDocuments());
    var qs = require("qs");
    this.props.history.push("/documents?" + qs.stringify(qData));
  };

  getFilesResult = (files) => {
    const { translate } = this.props;
    return (
      <table
        className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
        cellSpacing="0"
        style={{ border: "0px", padding: "0px" }}
      >
        <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
          {files.map((item, index) => (
            <tr
              key={index}
              className="row_tr"
              onClick={(e) => {
                this.handleRowClick(e, item);
              }}
            >
              <td
                className={
                  "file-flow-column name-column home-row-status-" +
                  item.status.id
                }
              >
                <div
                  className="w_p_action external_hide_link"
                  title={"Open flow - File name: " + item.file.shortname}
                >
                  {item.mode === "test" ? (
                    <span>
                      <i>[TEST]</i> <b>{item.file.shortname}</b>
                    </span>
                  ) : (
                    <div>
                      <b>{item.file.shortname}</b>
                    </div>
                  )}
                </div>
              </td>

              <td className="hidden-sm-screen-home" style={{ width: "180px", display: 'flex' }}>
                <div
                  style={{
                    textTransform: "uppercase",
                    float: "left",
                    textAlign: "center",
                    marginLeft: "1.5em",
                  }}
                  className={"tag-status-label status-" + item.status.id}
                >
                  {this.props.translate(item.status.id)}
                </div>
              </td>
              <td style={{ padding: ".1rem" }} className="text-center">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.handleOpenFilesFromFile(item)}
                  style={{ lineHeight: ".9", marginLeft: "5px" }}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  data-container="body"
                  title="Navigate to the original file"
                >
                  <span className="fa fa-file" /> {translate("View file")}
                </button>
              </td>
              {item.docs > 0 ? (
                <td
                  className="text-center w_p_action underline finger w_p_action_tooltip file-docs-column"
                  data-action="open_documentbucketall"
                  data-container="body"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Open Documents"
                >
                  <button
                    className="btn btn-secondary"
                    onClick={() => this.navigateToFileDocs(item)}
                    style={{ lineHeight: ".9", marginLeft: "5px" }}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-container="body"
                    title="Navigate to documents"
                  >
                    <span className="fa fa-file" /> {translate("View")}{" "}
                    {item.docs}{" "}
                    {isMobile
                      ? "docs"
                      : item.docs === 1
                      ? translate("document")
                      : translate("documents")}
                  </button>
                </td>
              ) : (
                <td className="text-center">TBD</td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  getDocsResult = (files) => {
    const { translate, tagsIcons } = this.props;
    return (
      <table
        className="table-bordered table-condensed cf table-hover table-sm panel-default col-12 col-lg-offset-0 card-list-table"
        cellSpacing="0"
        style={{ border: "0px", padding: "0px" }}
      >
        <tbody style={{ backgroundColor: "#fff", fontSize: "12px" }}>
          {files.map((item, index) => (
            <tr
              key={index}
              className="row_tr"
              onClick={(e) => {
                this.handleRowClick(e, item);
              }}
            >
              <td
                className={
                  "doc-documentNr-column name-column home-row-status-" +
                  item.status
                }
              >
                <div className="documentNr-content">
                  <div className="finger w_p_action">
                    {item.mode === "test" && (
                      <span>
                        <i>[TEST]</i>{" "}
                      </span>
                    )}{" "}
                    {item.documentNr || <i>[Not defined]</i>}
                  </div>
                </div>
              </td>

              <td className="hidden-sm-screen-home" style={{ width: "180px" }}>
                <div
                  style={{
                    textTransform: "uppercase",
                    float: "left",
                    textAlign: "center",
                    marginLeft: "1.5em",
                  }}
                  className={"tag-status-label status-" + item.status}
                >
                  {translate(item.status)}
                </div>
              </td>
              <td>
                {item.bst && (
                  <>
                    <span
                      style={item.bst.n ? { color: "red" } : {}}
                      data-tip
                      data-place="bottom"
                      data-type="info"
                      data-effect="solid"
                      data-for={`doc-bst-${item.docnodeid}`}
                    >
                      <i
                        className={`fa fa-${(
                          tagsIcons[item.bst.st.toLowerCase()] || "user-check"
                        ).replace("fa-", "")}`}
                        style={{ padding: "0 5px" }}
                      />
                      <span
                        style={{
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                      >
                        {item.bst.st}
                      </span>
                    </span>
                    <ReactTooltip
                      className="customeTheme"
                      id={`doc-bst-${item.docnodeid}`}
                    >
                      <div>
                        <strong>{translate("Date")}:</strong>{" "}
                        {item.bst.ts
                          ? moment
                              .utc(item.bst.ts, moment.ISO_8601)
                              .format("DD-MM-YYYY HH:mm:ss")
                          : "n/a"}
                      </div>
                    </ReactTooltip>
                  </>
                )}
              </td>
              <td style={{ padding: ".1rem" }} className="text-center">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.handleOpenFilesFromDoc(item)}
                  style={{ lineHeight: ".9", marginLeft: "5px" }}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  data-container="body"
                  title="Navigate to the original file"
                >
                  <span className="fa fa-file" />{" "}
                  {translate("Navigate to file")}
                </button>
              </td>
              <td style={{ padding: ".1rem" }} className="text-center">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.handleOpenDocument(item.docnodeid)}
                  style={{ lineHeight: ".9", marginLeft: "5px" }}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  data-container="body"
                  title="Navigate to the document"
                >
                  {translate("View details")}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  performSearch = (searchText) => {
    const {
      dispatch,
      subUser: { customerGlobalId },
      homeSearch: { CustomerId },
    } = this.props;

    const _params = {
      PageNumber: 1,
      Size: 2,
    };
    dispatch(
      homeActions.getFilteredFiles(
        getFilesParams(
          {
            ..._params,
            FileNames: searchText,
          },
          true,
          CustomerId || customerGlobalId
        )
      )
    );

    const ebidRegex = new RegExp(/^BEL[a-zA-Z0-9]{32}$/, "i");
    let documentSearchStarted = false;
    if (searchText && searchText.match(ebidRegex)) {
      dispatch(
        homeActions.getFilteredDocsbyEBID(
          getDocumentsWithoutPlatformSpecificParams(
            {
              ..._params,
              DocId: searchText,
            },
            true,
            CustomerId || customerGlobalId
          )
        )
      );
      documentSearchStarted = true;
    }
    if (!documentSearchStarted) {
      window.__sessionId++;
      window.__sessionId2++;
      dispatch(
        homeActions.getFilteredDocs(
          getDocumentsWithoutPlatformSpecificParams(
            {
              ..._params,
              DocumentNumbers: searchText,
            },
            true,
            CustomerId || customerGlobalId
          ),
          window.__sessionId
        )
      );
      dispatch(
        homeActions.getFilteredDocsByReceiver(
          getDocumentsWithoutPlatformSpecificParams(
            {
              ..._params,
              Receiver: searchText,
            },
            true,
            CustomerId || customerGlobalId
          ),
          window.__sessionId2
        )
      );
      dispatch(
        homeActions.getFilteredDocsByReceiver(
          getDocumentsWithoutPlatformSpecificParams(
            {
              ..._params,
              ByReceiverId: true,
              Receiver: searchText,
            },
            true,
            CustomerId || customerGlobalId
          ),
          window.__sessionId2
        )
      );

      dispatch(
        homeActions.getFilteredDocs(
          getDocumentsWithoutPlatformSpecificParams(
            {
              ..._params,
              DocId: searchText,
            },
            true,
            CustomerId || customerGlobalId
          ),
          window.__sessionId
        )
      );
    }
  };

  handleSearchClick = (event) => {
    this.performSearch(this.props.homeSearch.SearchText);
  };

  showMoreFiles = (event) => {
    event.preventDefault();
    const {
      dispatch,
      translate,
      history,
      subUser: { customerGlobalId },
      homeSearch: { SearchText, CustomerId },
    } = this.props;
    dispatch(
      actions.change("fileSearch", {
        ...initFilesSearchFormState,
        CustomerId,
        FileNames: SearchText,
      })
    );
    this.props.dispatch(
      fileActions.getAll(
        getFilesParams(
          {
            ...initFilesSearchFormState,
            FileNames: SearchText,
          },
          true,
          CustomerId || customerGlobalId
        ),
        `${translate("LoadingFiles")}...`
      )
    );
    history.push("/files");
  };

  showMoreDocs = (event) => {
    event.preventDefault();
    const {
      dispatch,
      translate,
      history,
      subUser: { customerGlobalId },
      homeSearch: { SearchText, CustomerId },
    } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        CustomerId,
        DocumentNumbers: SearchText,
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams(
          {
            ...initDocsSearchFormState,
            DocumentNumbers: SearchText,
          },
          true,
          CustomerId || customerGlobalId
        ),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  showMoreDocsByReceiver = (event) => {
    event.preventDefault();
    const {
      dispatch,
      translate,
      history,
      subUser: { customerGlobalId },
      homeSearch: { SearchText, CustomerId },
    } = this.props;
    dispatch(documentActions.clearDocuments());
    dispatch(
      actions.change("docSearch", {
        ...initDocsSearchFormState,
        ByReceiverId: false,
        CustomerId,
        Receiver: SearchText,
      })
    );
    dispatch(
      documentActions.getAll(
        getDocumentsWithoutPlatformSpecificParams(
          {
            ...initDocsSearchFormState,
            ByReceiverId: false,
            //CustomerId,
            Receiver: SearchText,
          },
          true,
          CustomerId || customerGlobalId
        ),
        `${translate("LoadingDocuments")}...`
      )
    );
    history.push("/documents");
  };

  handleOnPaste = (event) => {
    this.setState({ pasting: true, beforePasting: event.target.value });
  };

  render() {
    const {
      homeSearch,
      translate,

      externalUser24HFileCount,
      externalUser7DFileCount,
      externalUser24HDocsCount,
      externalUser7DDocsCount,
      externalLast5IncomingFiles,

      externalUser24HFileTestCount,
      externalUser7DFileTestCount,
      externalUser24HDocsTestCount,
      externalUser7DDocsTestCount,

      search_requested,
      search_requested_receiver,
      loading_files,
      externalFoundFiles,
      loading_docs,
      externalFoundDocs,

      loading_docs_by_receiver,
      externalFoundDocsByReceiver,

      filesShowMore,
      docsShowMore,

      docsByReceiverShowMore,

      byEBID,
    } = this.props;

    return (
      <div id="home_view" style={{ marginBottom: "6em" }}>
        <div className="w-100 top_search" style={{ textAlign: "center" }}>
          <SearchPanel
            view="homeView"
            searchParams={homeSearch}
            isExternalUser={true}
            handleParamChange={this.handleParamChange}
            handleOnPaste={this.handleOnPaste}
            onSearchClick={(params_) => {
              this.handleSearchClick(params_);
            }}
          />
        </div>
        <div
          id="home_content"
          className="fill col-lg-12 col-md-12 col-sm-12 col-xs-12"
        >
          <Container style={{ padding: "0 1em" }}>
            {search_requested ? (
              <>
                <Row style={{ marginTop: "1em" }}>
                  {loading_files ? (
                    <div style={{ padding: "0 5em 1em", color: "#aeaaaa" }}>
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {translate("Searching files")}...
                      </div>
                    </div>
                  ) : externalFoundFiles && externalFoundFiles.length ? (
                    <Col style={{ padding: 0 }}>
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          {translate("Found file (files)")}
                        </div>
                        <div className="panel-body">
                          {this.getFilesResult(externalFoundFiles)}
                        </div>
                      </div>
                    </Col>
                  ) : externalFoundFiles !== null ? (
                    <div
                      style={{
                        padding: "0 5em 1em",
                        color: "#aeaaaa",
                        fontStyle: "italic",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {translate("No files match your search text")}
                      </div>
                    </div>
                  ) : null}
                </Row>
                {!loading_files &&
                  externalFoundFiles &&
                  externalFoundFiles.length > 0 &&
                  filesShowMore && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={this.showMoreFiles}
                    >
                      {translate("Show more files")}
                    </button>
                  )}
              </>
            ) : null}
            {search_requested ? (
              <>
                <Row>
                  {loading_docs ? (
                    <div style={{ padding: "0 5em 1em", color: "#aeaaaa" }}>
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {translate("Searching documents")}
                        {byEBID && " by EBID"}...
                      </div>
                    </div>
                  ) : externalFoundDocs && externalFoundDocs.length ? (
                    <Col style={{ padding: 0 }}>
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          {translate("Found document (documents)")}
                        </div>
                        <div className="panel-body">
                          {this.getDocsResult(externalFoundDocs)}
                        </div>
                      </div>
                    </Col>
                  ) : externalFoundDocs !== null ? (
                    <div
                      style={{
                        padding: "0 5em 1em",
                        color: "#aeaaaa",
                        fontStyle: "italic",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {byEBID
                          ? translate("No documents match with EBID")
                          : translate("No documents match your search text")}
                      </div>
                    </div>
                  ) : null}
                </Row>
                {!loading_docs &&
                  externalFoundDocs &&
                  externalFoundDocs.length > 0 &&
                  docsShowMore && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={this.showMoreDocs}
                    >
                      {translate("Show more documents")}
                    </button>
                  )}
              </>
            ) : null}

            {search_requested_receiver ? (
              <>
                <Row className="search-result-panel">
                  {loading_docs_by_receiver ? (
                    <div style={{ padding: "0 5em 1em", color: "#aeaaaa" }}>
                      <div
                        className="spinner-border"
                        style={{ float: "left" }}
                      />
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {translate("Searching documents")}
                        {" by Receiver ID"}...
                      </div>
                    </div>
                  ) : externalFoundDocsByReceiver &&
                    externalFoundDocsByReceiver.length ? (
                    <Col style={{ padding: 0 }}>
                      <div className="panel panel-default">
                        <div className="panel-heading">
                          {translate("Found document (documents)")}
                          {" by Receiver ID"}
                        </div>
                        <div className="panel-body">
                          {this.getDocsResult(externalFoundDocsByReceiver)}
                        </div>
                      </div>
                    </Col>
                  ) : externalFoundDocsByReceiver !== null ? (
                    <div
                      style={{
                        padding: "0 5em 1em",
                        color: "#aeaaaa",
                        fontStyle: "italic",
                        fontWeight: "bold",
                      }}
                    >
                      <div style={{ float: "left", padding: "3px 10px" }}>
                        {translate("emptyDocsFoundByReceiver")}
                      </div>
                    </div>
                  ) : null}
                </Row>
                {!loading_docs_by_receiver &&
                  externalFoundDocsByReceiver &&
                  externalFoundDocsByReceiver.length > 0 &&
                  docsByReceiverShowMore && (
                    <button
                      style={{ margin: "5px" }}
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={this.showMoreDocsByReceiver}
                    >
                      {translate("Show more documents")}
                    </button>
                  )}
              </>
            ) : null}

            <Row style={{ marginTop: "3em" }}>
              {this.state.activeSummaryTab === "prod" && (
                <>
                  <Col
                    xs="6"
                    className="files-sammary-column"
                    style={{ padding: 0 }}
                    onClick={this.navigateToFile}
                  >
                    <div className="panel panel-default">
                      <div className="panel-heading">{translate("Files")}</div>
                      <div className="panel-body">
                        <Row>
                          <Col
                            xs="6"
                            data-action="24h"
                            data-run="p"
                            className="finger"
                          >
                            <div
                              data-action="24h"
                              data-run="p"
                              className="text-center txt-recent-period"
                            >
                              {translate("24 hours")}
                            </div>
                            <div
                              data-action="24h"
                              data-run="p"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser24HFileCount
                              )}
                            </div>
                          </Col>
                          <Col
                            xs="6"
                            data-action="7d"
                            data-run="p"
                            className="finger"
                          >
                            <div
                              data-action="7d"
                              data-run="p"
                              className="text-center txt-recent-period"
                            >
                              {translate("7 days")}
                            </div>
                            <div
                              data-action="7d"
                              data-run="p"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser7DFileCount
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs="6"
                    className="docs-sammary-column"
                    style={{ padding: 0 }}
                    onClick={this.navigateToDocs}
                  >
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        {translate("Incoming documents")}
                      </div>
                      <div className="panel-body">
                        <Row>
                          <Col
                            xs="6"
                            data-action="24h"
                            data-run="p"
                            className="finger"
                          >
                            <div
                              data-action="24h"
                              data-run="p"
                              className="text-center txt-recent-period"
                            >
                              {translate("24 hours")}
                            </div>
                            <div
                              data-action="24h"
                              data-run="p"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser24HDocsCount
                              )}
                            </div>
                          </Col>
                          <Col
                            xs="6"
                            data-action="7d"
                            data-run="p"
                            className="finger"
                          >
                            <div
                              data-action="7d"
                              data-run="p"
                              className="text-center txt-recent-period"
                            >
                              {translate("7 days")}
                            </div>
                            <div
                              data-action="7d"
                              data-run="p"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser7DDocsCount
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </>
              )}
              {this.state.activeSummaryTab === "test" && (
                <>
                  <Col
                    xs="6"
                    className="files-sammary-column"
                    style={{ padding: 0 }}
                    onClick={this.navigateToFile}
                  >
                    <div className="panel panel-default">
                      <div className="panel-heading">{translate("Files")}</div>
                      <div className="panel-body">
                        <Row>
                          <Col
                            xs="6"
                            data-action="24h"
                            data-run="t"
                            className="finger"
                          >
                            <div
                              data-action="24h"
                              data-run="t"
                              className="text-center txt-recent-period"
                            >
                              {translate("24 hours")}
                            </div>
                            <div
                              data-action="24h"
                              data-run="t"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser24HFileTestCount
                              )}
                            </div>
                          </Col>
                          <Col
                            xs="6"
                            data-action="7d"
                            data-run="t"
                            className="finger"
                          >
                            <div
                              data-action="7d"
                              data-run="t"
                              className="text-center txt-recent-period"
                            >
                              {translate("7 days")}
                            </div>
                            <div
                              data-action="7d"
                              data-run="t"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser7DFileTestCount
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs="6"
                    className="docs-sammary-column"
                    style={{ padding: 0 }}
                    onClick={this.navigateToDocs}
                  >
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        {translate("Incoming documents")}
                      </div>
                      <div className="panel-body">
                        <Row>
                          <Col
                            xs="6"
                            data-action="24h"
                            data-run="t"
                            className="finger"
                          >
                            <div
                              data-action="24h"
                              data-run="t"
                              className="text-center txt-recent-period"
                            >
                              {translate("24 hours")}
                            </div>
                            <div
                              data-action="24h"
                              data-run="t"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser24HDocsTestCount
                              )}
                            </div>
                          </Col>
                          <Col
                            xs="6"
                            data-action="7d"
                            data-run="t"
                            className="finger"
                          >
                            <div
                              data-action="7d"
                              data-run="t"
                              className="text-center txt-recent-period"
                            >
                              {translate("7 days")}
                            </div>
                            <div
                              data-action="7d"
                              data-run="t"
                              className="text-center txt-count"
                            >
                              {this.getFormatedValueStr(
                                externalUser7DDocsTestCount
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </>
              )}
              <div className="bottom-nav" style={{ height: "37px" }}>
                <Navbar color="light" light expand="md" style={{ padding: 0 }}>
                  <Nav className="mr-auto" navbar>
                    <NavItem
                      className={
                        this.state.activeSummaryTab === "prod"
                          ? "active-tab"
                          : ""
                      }
                    >
                      <NavLink
                        className={
                          this.state.activeSummaryTab === "prod"
                            ? "active-tab"
                            : ""
                        }
                        onClick={() =>
                          this.setState({ activeSummaryTab: "prod" })
                        }
                      >
                        {translate("Production")}
                      </NavLink>
                    </NavItem>
                    {(externalUser24HFileTestCount > 0 ||
                      externalUser7DFileTestCount > 0 ||
                      externalUser24HDocsTestCount > 0 ||
                      externalUser7DDocsTestCount > 0) && (
                      <NavItem
                        className={
                          this.state.activeSummaryTab === "test"
                            ? "active-tab"
                            : ""
                        }
                      >
                        <NavLink
                          className={
                            this.state.activeSummaryTab === "test"
                              ? "active-tab"
                              : ""
                          }
                          onClick={() =>
                            this.setState({ activeSummaryTab: "test" })
                          }
                        >
                          {translate("Test")}
                        </NavLink>
                      </NavItem>
                    )}
                  </Nav>
                </Navbar>
              </div>
            </Row>
            <Row style={{ marginTop: "2em" }}>
              <Col className="files-sammary-column" style={{ padding: 0 }}>
                <div className="panel panel-default">
                  <div className="panel-heading">
                    {translate("Last 5 incoming files")}
                  </div>
                  <div
                    className="panel-body"
                    style={{ borderWidth: "2px 2px 2px 2px" }}
                  >
                    {this.getIncomingFiles(externalLast5IncomingFiles)}
                  </div>
                </div>
              </Col>
            </Row>
            <DeliveryChannels />
          </Container>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { homeSearch, authentication, locale, config } = state;
  const { subUser } = authentication;
  return {
    externalUser24HFileCount: state.home.externalUser24HFileCount,
    externalUser7DFileCount: state.home.externalUser7DFileCount,
    externalUser24HDocsCount: state.home.externalUser24HDocsCount,
    externalUser7DDocsCount: state.home.externalUser7DDocsCount,
    externalLast5IncomingFiles: state.home.externalLast5IncomingFiles,

    externalUser24HFileTestCount: state.home.externalUser24HFileTestCount,
    externalUser7DFileTestCount: state.home.externalUser7DFileTestCount,
    externalUser24HDocsTestCount: state.home.externalUser24HDocsTestCount,
    externalUser7DDocsTestCount: state.home.externalUser7DDocsTestCount,
    externalLast5IncomingTestFiles: state.home.externalLast5IncomingTestFiles,

    search_requested: state.home.search_requested,
    search_requested_receiver: state.home.search_requested_receiver,

    loading_files: state.home.loading_files,
    externalFoundFiles: state.home.externalFoundFiles,
    loading_docs: state.home.loading_docs,
    externalFoundDocs: state.home.externalFoundDocs,

    loading_docs_by_receiver: state.home.loading_docs_by_receiver,
    externalFoundDocsByReceiver: state.home.externalFoundDocsByReceiver,

    filesShowMore: state.home.filesShowMore,
    docsShowMore: state.home.docsShowMore,
    docsByReceiverShowMore: state.home.docsByReceiverShowMore,

    byEBID: state.home.byEBID,

    homeSearch,
    subUser,
    translate: getTranslate(locale),
    tagsIcons: config.tagsIcons,
  };
}

const connectedHome = connect(mapStateToProps)(withRouter(Home));
export { connectedHome as Home };
